import React from 'react'
import { FormattedMessage } from 'react-intl'

const menu = [
  {
    tab: 1,
    child: <FormattedMessage id="Favorite Instructors" defaultMessage="Favorite Instructors" />,
  },
  {
    tab: 2,
    child: <FormattedMessage id="Past Instructors" defaultMessage="Past Instructors" />,
  },
  {
    tab: 3,
    child: <FormattedMessage id="Blocked Instructors" defaultMessage="Blocked Instructors" />,
  },
  {
    tab: 4,
    child: <FormattedMessage id="Session Preferences" defaultMessage="Session Preferences" />,
  },
]

export default menu
